<i data-toggle="modal" data-target="#help-modal" class="fas pointer fa-question"></i>

<!-- Modal -->
<div class="modal fade" id="help-modal" tabindex="-1" role="dialog" aria-labelledby="help-modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-givt-purple text-heavy-font" id="help-modalLabel">{{ title | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-left text-givt-purple text-light-font" innerHtml="{{ text | translate }}"></div>
    </div>
  </div>
</div>
